module.exports = __webpack_public_path__ + "img/character-shadow.831a2dc0.svg";